import React, { useState } from "react";
import api, { formatApiError } from "@/lib/upr-api";
import { toast } from "sonner";
import { Mail } from "lucide-react";

export default function NewsletterForm({ source = "footer", testid = "newsletter" }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/newsletter/subscribe", { email, source });
      setDone(true);
      setEmail("");
      toast.success("Subscribed — check your inbox.");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Could not subscribe.");
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <div className="text-sm" data-testid={`${testid}-done`} style={{ color: "var(--upr-secondary)" }}>
        Subscribed. Check your inbox for a welcome note.
      </div>
    );
  }

  return (
    <form onSubmit={onSubmit} className="flex items-stretch gap-2" data-testid={`${testid}-form`}>
      <div className="relative flex-1">
        <Mail size={14} className="absolute left-3 top-1/2 -translate-y-1/2" style={{ color: "var(--upr-muted)" }} />
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="your@email.com"
          data-testid={`${testid}-email`}
          className="w-full pl-9 pr-3 py-2 bg-transparent border focus:outline-none focus:border-[color:var(--upr-primary)] text-sm"
          style={{ borderColor: "var(--upr-border)" }}
        />
      </div>
      <button type="submit" disabled={busy} className="upr-btn shrink-0" data-testid={`${testid}-submit`} style={{ padding: "0.5rem 1rem" }}>
        {busy ? "…" : "Subscribe"}
      </button>
    </form>
  );
}
